export default __webpack_public_path__ + "static/media/gallery_00.eda059f8.jpg";